import React,{ useState } from 'react';
import styled from 'styled-components'
import NormalText from './BoldText';
import {media} from '../styles/Mixin'
import SelectBox from './SelectBox';
import { useQuery, useMutation } from '@apollo/react-hooks'
import { SEE_REQUESTUSER_CATEGORY } from '../Queries/Category/seeRequestUserCategory';
import Loader from './Loader';
import { SEE_REQUESTUSER_TOPCOMMENT } from '../Queries/TopComment/seeRequestUserTopComment';
import { SAVE_TOPCOMMENT } from '../Queries/TopComment/saveTopComment';
import { SAVE_RECOMMENT } from '../Queries/ReComment/saveReComment';
import { DELETE_TOPCOMMENT } from '../Queries/TopComment/deleteTopComment';


export const SaveInCategoryWindow =({
    comment,
    setSaveCtgWindow,
    setCreateCategoryWindow,
    setBtnState:saveBtnState,
    setDeleteState
})=>{
    /**
     * 1. useQuery 필요 
     */
    const {data, loading} = useQuery(SEE_REQUESTUSER_CATEGORY)
    const {data:data_rtc, loading:loading_rtc} = useQuery(SEE_REQUESTUSER_TOPCOMMENT)
    const [btnState, setBtnState] = useState(false)
    const [saveInfo, setSaveInfo] = useState([])
    const [deleteInfo, setDeleteInfo] = useState([])
    const [saveTopCommentMutation] = useMutation(SAVE_TOPCOMMENT, {
       async update(cache, { data: { saveTopComment } }) {
        const { seeRequestUserTopComment } = cache.readQuery({
          query: SEE_REQUESTUSER_TOPCOMMENT
        });
        await cache.writeQuery({
          query: SEE_REQUESTUSER_TOPCOMMENT,
          data: {
            seeRequestUserTopComment: [
              ...seeRequestUserTopComment,
              saveTopComment,
            ],
          },
        });
        saveBtnState(false)
      },
    });
    const [saveReCommentMutation] = useMutation(SAVE_RECOMMENT)
  const [deleteTopCommentMutation]  = useMutation(DELETE_TOPCOMMENT,{
    refetchQueries: ["seeRequestUserTopComment"],
    awaitRefetchQueries:true,
    onCompleted:()=>{
      console.log("delete completed")
      setDeleteState(false)
    }
    })
    const saveIn = async()=>{
      // saveInfo가 하나라도 되어있어야함. 혹은 취소나 등등
      // save, delete
      setBtnState(true)
      // saveinfo.length create
      // deleteInfo.length delete
        if(saveInfo.length > 0){
          saveInfo.map(async(id)=>{
            const { data } = await saveTopCommentMutation(
              {
                variables: {
                  categoryId: id,
                  topCommentId: comment.snippet ? (comment.snippet.topLevelComment.id) :  comment.topCommentId,
                  videoId: comment.snippet ? (comment.snippet.topLevelComment.snippet.videoId) : comment.videoId,
                  makerChannelId:comment.snippet ? (comment.snippet.topLevelComment.snippet.authorChannelId.value ) : comment.makerChannelId,
                  makerChannelDisplayName:comment.snippet ? ( comment.snippet.topLevelComment.snippet.authorDisplayName ) : comment.makerChannelDisplayName,
                  makerChannelProfileImageUrl: comment.snippet ? ( comment.snippet.topLevelComment.snippet.authorProfileImageUrl ) : comment.makerChannelProfileImageUrl,
                  makerUpdatedAt: comment.snippet ? (new Date(comment.snippet.topLevelComment.snippet.updatedAt)) :new Date(comment.makerUpdatedAt),
                  makerPublishedAt: comment.snippet ?  new Date(comment.snippet.topLevelComment.snippet.publishedAt): new Date(comment.makerPublishedAt),
                  textOriginal:comment.snippet ? comment.snippet.topLevelComment.snippet.textOriginal : comment.textOriginal,
                  likeCount: comment.snippet ? comment.snippet.topLevelComment.snippet.likeCount : comment.likeCount,
                },
              }
            );
            if(comment.snippet){
              if(comment.snippet.totalReplyCount > 0){
                comment.replies.comments.map(async(comment)=>{
                  await saveReCommentMutation({
                    variables:{
                      reCommentId: comment.id,
                      videoId: comment.snippet.videoId,
                      makerChannelId: comment.snippet.authorChannelId.value,
                      makerChannelDisplayName: comment.snippet.authorDisplayName,
                      makerChannelProfileImageUrl: comment.snippet.authorProfileImageUrl,
                      makerUpdatedAt: new Date(comment.snippet.updatedAt),
                      makerPublishedAt: new Date(comment.snippet.publishedAt),
                      textOriginal: comment.snippet.textOriginal,
                      likeCount: comment.snippet.likeCount,
                      topCommentId: data.saveTopComment.id
                    }
                  })
                })
              }
            }else{
                   if(comment.reComment.length > 0){
                comment.reComment.map(async(comment)=>{
                  await saveReCommentMutation({
                    variables:{
                      reCommentId: comment.reCommentId,
                      videoId: comment.videoId,
                      makerChannelId: comment.makerChannelId,
                      makerChannelDisplayName: comment.makerChannelDisplayName,
                      makerChannelProfileImageUrl: comment.makerChannelProfileImageUrl,
                      makerUpdatedAt: new Date(comment.makerUpdatedAt),
                      makerPublishedAt: new Date(comment.makerPublishedAt),
                      textOriginal: comment.textOriginal,
                      likeCount: comment.likeCount,
                      topCommentId: data.saveTopComment.id
                    }
                  })
                })
              }
            }
          })
        }else{
          saveBtnState(false)
          // save 정보
        }
        if(deleteInfo.length > 0){
          deleteInfo.map(async(id)=>{
            await deleteTopCommentMutation({
              variables: {
                categoryId: id,
                topCommentId: comment.snippet ? comment.snippet.topLevelComment.id : comment.topCommentId
              }
            });
          })
        }else{
          setDeleteState(false)
          // delete 정보
        }
      setBtnState(false)
      setSaveCtgWindow(false)
    }

    if(loading ||  loading_rtc){
        return (
          <Wrapper>
            <Box>
              <Header>
                <NormalText text={"저장"} />
                <NewCategoryText
                  text={"+ 새 카테고리 만들기"}
                  onClick={() => {
                    setSaveCtgWindow(false);
                    setCreateCategoryWindow(true);
                  }}
                />
              </Header>
              <Content>
                <Loader />
              </Content>
              <Footer>
                <CancelBtn
                  onClick={() => {
                    setSaveCtgWindow(false);
                  }}
                  disabled={btnState}
                >
                  <CancelText text={"🙅🏻취소"} />
                </CancelBtn>
                <CreateBtn onClick={saveIn} disabled={btnState}>
                  <CreateText text={"✔️저장"} />
                </CreateBtn>
              </Footer>
            </Box>
          </Wrapper>
        );
    }else if(!loading && !loading_rtc && data && data_rtc){
        return (
          <Wrapper>
            <Box>
              <Header>
                <NormalText text={"저장"} />
                <NewCategoryText
                  text={"+ 새 카테고리 만들기"}
                  onClick={() => {
                    setSaveCtgWindow(false);
                    setCreateCategoryWindow(true);
                  }}
                />
              </Header>
              <Content>
                {data.seeRequestUserCategory.map((category, i) => (
                  <EachContent key={i}>
                    <SelectBox
                      data={category}
                      order={i}
                      saveInfo={saveInfo}
                      setSaveInfo={setSaveInfo}
                      deleteInfo={deleteInfo}
                      setDeleteInfo={setDeleteInfo}
                      comment={comment}
                      topCommentData={data_rtc}
                    />
                  </EachContent>
                ))}
              </Content>
              <Footer>
                <CancelBtn
                  onClick={() => {
                    setSaveCtgWindow(false);
                    saveBtnState(false);
                    setDeleteState(false)
                  }}
                  disabled={btnState}
                >
                  <CancelText text={"🙅🏻취소"} />
                </CancelBtn>
                <CreateBtn onClick={saveIn} disabled={btnState}>
                  <CreateText text={"✔️저장"} />
                </CreateBtn>
              </Footer>
            </Box>
          </Wrapper>
        );
    }
} 


const Wrapper = styled.div`
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.5);
    height:100%;
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Box = styled.div`
   position:relative;
   display:flex;
   flex-direction:column;
   background-color:white;
   ${media.deskTop`
    width:500px;
    height:450px;
   `}
    ${media.mobile`
        width:100%;
        height:300px;
    `}
    width:100%;
`

const Header = styled.div`
    display:flex;
    position:relative;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    padding:10px;
    top:0;
    height:40px;
    border-bottom:${props => props.theme.boxBorder};
`

const Content = styled.div`
    height:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    overflow-y: auto;
    ${media.deskTop`
        padding:20px;
   `};
    ${media.mobile`
        padding:15px;
    `};
    &>:not(:last-child){
      ${media.deskTop`
          margin-bottom:20px;
      `};
      ${media.mobile`
         margin-bottom:15px;
      `};
    };
`

const EachContent = styled.div`
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    width:100%;
`


// const GuidText = styled(NormalText)`
//     ${media.deskTop`
//      font-size:30px;
//    `}
//     ${media.mobile`
//     height:15px;
//     `}
//     color:grey;
//     padding:20px;
// `

// const CustomInput = styled(Input)`
//     ${media.deskTop`
//      height:40px;
//      width:60%;
//    `}
//     ${media.mobile`
//     height:25px;
//     width:50%;
//     `}
//     border-radius:10px;
// `


const Footer = styled.div`
     position:relative;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    bottom:50;
     ${media.deskTop`
     height:50px;
   `}
    ${media.mobile`
    height:40px;
    `}
    border-top:${props => props.theme.boxBorder};
    /* padding:10px; */
`

const CancelBtn = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:50%;
    height:100%;
    background-color:${props => props.disabled === true ? props.theme.unCheckBlack : "red"};
    cursor:pointer;
`
const CancelText = styled(NormalText)`

`

const CreateBtn = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:50%;
    height:100%;
    background-color:${props => props.disabled === true ? props.theme.unCheckBlack : props.theme.blueColor};
    cursor:pointer;
`

const CreateText = styled(NormalText)`
`

const NewCategoryText=  styled(NormalText)`
    color:${props => props.theme.blueColor};
    cursor:pointer;
`